var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-autocomplete',{attrs:{"value":_vm.value,"fetch-suggestions":_vm.querySearchCityAsync,"clearable":"","value-key":"name"},on:{"select":_vm.handleSelect,"input":_vm.handleInput},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.name)+" / "+_vm._s(item.county)+" / "+_vm._s(item.iczuj))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }